import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import BookNowTheaterStep from "./BookNowTheaterStep";
import BookingFormPage from "./BookingFormPage";
import AddonsWizardPage from "./AddonsWizardPage";
import ReviewPayPage from "./ReviewPayPage";
import ResumePaymentPage from "./ResumePaymentPage";
import "../partyBossTheme.css";

/**
 * /booknow        — pick theatre + slot
 * /booknow/booking-form — customer & event details
 * /booknow/addons — add-ons (sidebar layout)
 * /booknow/review — review + Razorpay
 */
const BookNow = () => {
  useEffect(() => {
    document.body.classList.add("party-boss-home");
    return () => document.body.classList.remove("party-boss-home");
  }, []);

  return (
    <Routes>
      <Route index element={<BookNowTheaterStep />} />
      <Route path="booking-form" element={<BookingFormPage />} />
      <Route path="addons" element={<AddonsWizardPage />} />
      <Route path="review" element={<ReviewPayPage />} />
      <Route path="resume-payment" element={<ResumePaymentPage />} />
      <Route path="*" element={<Navigate to="/booknow" replace />} />
    </Routes>
  );
};

export default BookNow;
